import { t } from 'i18next';
import * as yup from 'yup';

export const resendEmailVerificationLinkSchema = () =>
  yup.object().shape({
    email: yup.string().trim().label(t('labelEmailAddress')).email().nullable().required(),
  });
